import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import classNames from 'classnames';
import { Input as RsInput } from 'reactstrap';
import { useField } from 'formik';

var Input = function Input(_ref) {
  var Tag = _ref.tag,
      className = _ref.className,
      name = _ref.name,
      validate = _ref.validate,
      rest = _objectWithoutPropertiesLoose(_ref, ["tag", "className", "name", "validate"]);

  var _useField = useField({
    name: name,
    validate: validate
  }),
      field = _useField[0],
      metadata = _useField[1];

  var classes = classNames(className, metadata.touched ? 'is-touched' : 'is-untouched', metadata.error ? 'av-invalid' : 'av-valid', metadata.touched && metadata.error && 'is-invalid', rest.type === 'checkbox' && metadata.touched && metadata.error && 'was-validated');
  var extraProps = {};

  if (rest.type === 'checkbox') {
    extraProps.checked = !!field.value;
  }

  return React.createElement(Tag, Object.assign({
    className: classes,
    name: name
  }, field, extraProps, rest));
};

Input.defaultProps = {
  tag: RsInput
};
export default Input;